import styled from 'styled-components';
import { LabeledSelectContainerProps } from './Select.types';
import { OptimizedSelect } from './OptimizedSelect';

export const LabeledSelectContainer = styled.div<LabeledSelectContainerProps>`
  display: flex;
  align-items: center;
  column-gap: var(--allie-spacing-lg);
  flex-grow: 1;
  background-color: var(--allie-color-white);
  border-radius: ${({ borderRadius }) => borderRadius || 'var(--allie-radius-md)'};
  padding-inline-start: var(--allie-spacing-lg);
  padding-block: var(--allie-spacing-xxs);
  border-style: ${({ borderStyle }) => borderStyle || 'none'};
  border-color: ${({ borderColor }) => `var(--allie-color-${borderColor || 'neutral-20'})`};
  border-width: ${({ borderWidth }) => borderWidth || '1px'};
  box-shadow: ${({ boxShadow }) => (boxShadow ? `var(--allie-shadow-${boxShadow})` : 'none')};
  justify-content: ${({ justify }) => justify || 'start'};
`;

export const SelectStyled = styled(OptimizedSelect)`
  border: none;
  font-weight: 400;
  font-size: 12px;
  --padding-end: var(--allie-spacing-lg);
  --padding-top: var(--allie-spacing-md);
  --padding-bottom: var(--allie-spacing-md);
  --padding-start: 0;
  box-shadow: none;

  &::part(icon) {
    color: var(--allie-color-neutral-60);
    opacity: 1;
  }

  &::part(text) {
    color: var(--allie-color-neutral-70);
    font-size: 14px;
    font-weight: 400;
  }
`;
